import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AccountService } from 'src/app/shared/services/account.service';

@Component({
  selector: 'app-cancel-booking',
  templateUrl: './cancel-booking.component.html',
  styleUrls: ['./cancel-booking.component.scss'],
})
export class CancelBookingComponent {
  @Input() userId;

  @Input() channelUrl;

  constructor(
    public modalCtrl: ModalController,
    public accountService: AccountService,
  ) {}
}
